import {
  parsePhoneNumberFromString,
  type CountryCode,
} from "libphonenumber-js/min";

/** Matches the shared email validation used across tasks, sequences, and inbox. */
export const MANUAL_CONTACT_EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const DEFAULT_MANUAL_CONTACT_PHONE_COUNTRY: CountryCode = "US";

export function validateManualContactEmail(value: string): string | null {
  const trimmed = value.trim();
  if (!trimmed) return "Enter an email address";
  if (!MANUAL_CONTACT_EMAIL_REGEX.test(trimmed)) {
    return "Enter a valid email address";
  }
  return null;
}

function parseManualContactPhone(
  value: string,
  defaultCountry: CountryCode = DEFAULT_MANUAL_CONTACT_PHONE_COUNTRY,
) {
  const trimmed = value.trim();
  return (
    parsePhoneNumberFromString(trimmed) ??
    parsePhoneNumberFromString(trimmed, defaultCountry)
  );
}

export function validateManualContactPhone(
  value: string,
  defaultCountry: CountryCode = DEFAULT_MANUAL_CONTACT_PHONE_COUNTRY,
): string | null {
  const trimmed = value.trim();
  if (!trimmed) return "Enter a phone number";
  if (!parseManualContactPhone(trimmed, defaultCountry)?.isValid()) {
    return "Enter a valid phone number";
  }
  return null;
}

export function normalizeManualContactEmail(value: string): string {
  return value.trim();
}

export function normalizeManualContactPhone(
  value: string,
  defaultCountry: CountryCode = DEFAULT_MANUAL_CONTACT_PHONE_COUNTRY,
): string {
  const trimmed = value.trim();
  const parsed = parseManualContactPhone(trimmed, defaultCountry);
  return parsed?.isValid() ? parsed.format("E.164") : trimmed;
}
